import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import BrandHero from "@/components/Brand";
import { Heart, Radar, LogOut, ChevronRight } from "lucide-react";

export default function Portal() {
  const nav = useNavigate();
  const { logout, setPanel } = useAuth();

  const go = async (panel, path) => {
    try { await setPanel(panel); } catch {}
    nav(path);
  };

  const Card = ({ testid, icon: Icon, title, desc, onClick, tint }) => (
    <button data-testid={testid} onClick={onClick}
      className="group relative flex-1 min-h-[300px] rounded-3xl overflow-hidden border border-white/10 bg-surface p-8 text-left transition-all hover:border-brand/50 hover:-translate-y-1">
      <div className={`absolute -top-16 -right-16 w-56 h-56 rounded-full blur-[90px] ${tint}`} />
      <div className="relative z-10 h-full flex flex-col">
        <div className="w-14 h-14 rounded-2xl bg-white/5 flex items-center justify-center mb-6 group-hover:bg-brand transition-colors">
          <Icon className="w-7 h-7 text-white" />
        </div>
        <h2 className="font-heading text-2xl font-bold tracking-tight">{title}</h2>
        <p className="text-muted-foreground mt-3 leading-relaxed flex-1">{desc}</p>
        <span className="inline-flex items-center gap-1.5 text-brand font-semibold mt-4">
          Enter <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </button>
  );

  return (
    <div className="min-h-screen bg-ink grain relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full bg-brand/10 blur-[120px]" />
      <button data-testid="portal-logout" onClick={() => { logout(); nav("/login"); }}
        className="absolute top-6 right-6 z-20 flex items-center gap-2 text-sm text-muted-foreground hover:text-white">
        <LogOut className="w-4 h-4" /> Logout
      </button>
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-16">
        <BrandHero className="mb-14" />
        <div className="flex flex-col md:flex-row gap-6">
          <Card testid="portal-companion" icon={Heart} tint="bg-brand/30"
            title="The Companion Hub"
            desc="Design and bond with your personal AI companion. Customize their look, personality, and watch your trust deepen over time."
            onClick={() => go("companion", "/app")} />
          <Card testid="portal-blinddate" icon={Radar} tint="bg-cyan-500/20"
            title="Blind Date Roulette"
            desc="Get matched with a localized profile near you on a mysterious blind-date grid. Spark a connection and see where it leads."
            onClick={() => go("blinddate", "/blinddate")} />
        </div>
      </div>
    </div>
  );
}
